import { AxiosError, AxiosResponse } from 'axios'
import { useInfiniteQuery, useQuery } from 'react-query'

import * as requests from './requests'
import { GetListSubsegments, GetListsParams, Store } from './types'
import { ResponseError, ResponseSuccess } from '../../types'

export const KEY_STORE_LIST_QUERY = 'getStoreList'

export const useGetStoreListInfiniteQuery = (params: GetListsParams) =>
  useInfiniteQuery<AxiosResponse<ResponseSuccess<Store[]>>, AxiosError<ResponseError>>(
    [KEY_STORE_LIST_QUERY, params],
    ({ pageParam }) => requests.getStoreList({ ...params, page: pageParam }),
    {
      getNextPageParam: (lastPage) =>
        lastPage.data.metadata.pagination.current_page < lastPage.data.metadata.pagination.last_page
          ? lastPage.data.metadata.pagination.current_page + 1
          : false
    }
  )

export const useGetSubsegmentQuery = () =>
  useQuery<AxiosResponse<ResponseSuccess<GetListSubsegments[]>>, AxiosError<ResponseError>>(
    'getListSubsegment',
    requests.getListSubsegment
  )

export const useGetStatusTabQuery = () =>
  useQuery<AxiosResponse<ResponseSuccess<string[]>>, AxiosError<ResponseError>>(
    'getListStatusTab',
    requests.getListStatusTab
  )
